import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d281bee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2d281bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/nuxt/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d281bee",
  null
  
)

export default component.exports